export var DEPLOY_DATE = new Date('2026-10-12T14:25:53+0000');
